export default {
  home: {
    title: '聚展网-展会网_国际展会_展会门票_展会信息服务平台',
    keywords: '展会,博览会,展会门票,展会会刊,交易会,展会信息',
    description:
      '聚展网为您提供专业的展会信息服务,展会门票,展会会刊,展位预定,展会推广,展会行程,展会物流,展会搭建,展位设计,专业观众引流,展会信息触达全球一百多个国家'
  },
  ticket: '门票',
  time: '时间',
  magazine: '会刊',
  address2: '地点',
  jufair: '聚展',
  jufair2: '聚展网',
  fairTime: '展会时间',
  address: '展会地点',
  sponsor: '主办方',
  // 展会详情页
  exhibitionDetail: {
    description: '聚展网提供展会门票和展位预订服务',
    keyword1: '展',
    keyword2: '展时间',
    keyword3: '展门票',
    keyword4: '展展位图',
    keyword5: '展价格'
  }
}
